import React from "react";
import "./ContactUs.css";

export default function ContactUs() {
    return (
        <div class="container" style={{position: 'relative', maxWidth: '1100px', padding: '0 15px'}}>
            <h3 style={{fontFamily: 'robotolight', fontWeight: 'lighter'}}><span>feedback@ogame.tools</span></h3>
        </div>
    )
}